//hooks
import { DndProvider } from "react-dnd";
import { TouchBackend } from 'react-dnd-touch-backend';
import UseSimpleTable from "./SimpleTable.hooks";

//components
import DirectionalToggle from "../../toggles/DirectionalToggle/DirectionalToggle";
import SimpleRow from "./SimpleRow/SimpleRow";
import DragAndDropRow from "./DragAndDrop/DragAndDropRow";
import LoadingSpinner from "@/components/elements/search/LoadingSpinner/LoadingSpinner";

//interfaces
import { Direction } from "../../../../../interfaces/toggle";
import { ITableProps } from "../../../../../interfaces/simpleTable";

//styling
import "../../../../../css/global/tables/simpleTable.scss";



const SimpleTable = ({simpleTableContent, noDataMessage, isInfiniteScroll = false, maxContentLength, getMoreContent, isDragAndDrop = false, isPaginated = false, paginationInformation, infiniteScrollFetchCondition, isLoading=true}: ITableProps) => {

    const {
        noContentMessage,
        showNoContentMessage,
        infiniteScrollRef,
        displayedContent,
        hasControlsColumn,
        controlIndex,
        setControlIndex,
        toggleDirections,
        handleToggleDirection,
        containerRef,
        setHoverIndex,
        hoverIndex,
        moveRow,
        openMenu,
        setOpenMenu,
        defaultSortIsUnchecked,
        setDefaultSortIsUnchecked,
        isLoadingMore
    } = UseSimpleTable(simpleTableContent.rows,isInfiniteScroll, getMoreContent, maxContentLength, noDataMessage, infiniteScrollFetchCondition);

    return (
        <DndProvider backend={TouchBackend} options={{enableMouseEvents: true}}>
            <div className='simple-table-wrapper' ref={containerRef}>
                <table className="simple-table">
                    <thead className={`simple-table-header`}>
                        <tr key={100}>
                            {simpleTableContent.columns.map((column, index) => (
                                column
                                ?   <th key={`table-header-${index}`}>
                                        
                                        {column.isToggleButton
                                            ? <DirectionalToggle 
                                                direction={toggleDirections[index]}
                                                sortAscending={() => {handleToggleDirection(index, Direction.UP); column.onSortAscendingClick()}}
                                                sortDescending={()=> {handleToggleDirection(index, Direction.DOWN); column.onSortDescendingClick()}}
                                                text={column.title}
                                                defaultSort={defaultSortIsUnchecked ? undefined : column.defaultSort}
                                                onRemoveDefaultSort={() =>setDefaultSortIsUnchecked(true)}

                                            />
                                            :
                                            <>{column.title}</> 
                                        }
                                    </th>
                                :   <th className="empty-column" key={`table-header-${index}`} />

                            ))}
                            
                            {(isDragAndDrop || hasControlsColumn || (isLoading && hasControlsColumn)) && <th className="controls-column">Actions</th>}
                        </tr>
                    </thead>

                    {isLoading  
                        ?   (<tbody className="full-width">
                                <tr><td className='no-data-cell' colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}>
                                    <span id="no-data-message" className="no-data-message"><LoadingSpinner size={22}/></span>
                                </td></tr>
                            </tbody>)
                    
                        :   (showNoContentMessage
                            ?   <tbody className="full-width">
                                    <tr>
                                        <td className='no-data-cell' colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}>
                                            <span id="no-data-message" className="no-data-message">{noContentMessage}</span>
                                        </td>
                                    </tr>
                                </tbody> 
                            :   <tbody className={`simple-table-body ${isDragAndDrop && "drag-and-drop"} `}> 
                                    {isDragAndDrop 
                                        ?   displayedContent.map((row, rowIndex) => (
                                                <DragAndDropRow
                                                    key={`table-row-${rowIndex}`}
                                                    isHighlightedRow={row.isHighlightedRow}
                                                    index={rowIndex}
                                                    row={row}
                                                    containerRef={containerRef}
                                                    hoverIndex={hoverIndex}
                                                    controlIndex={controlIndex}
                                                    setControlIndex={setControlIndex}
                                                    moveRow={moveRow}
                                                    rowContentLength={displayedContent.length}
                                                    setHoverIndex={setHoverIndex}
                                                    openMenu={openMenu}
                                                    setOpenMenu={setOpenMenu}
                                                    dragAndDropAction={row.dragAndDropAction}
                                                    isPaginated={isPaginated}
                                                    paginationInformation={paginationInformation}
                                                />
                                            ))
                                        :   displayedContent.map((row, rowIndex) => (
                                                <SimpleRow
                                                    key={`table-row-${rowIndex}`}
                                                    isHighlightedRow={row.isHighlightedRow}
                                                    setControlIndex={() => setControlIndex(rowIndex)}
                                                    row={row} isControlIndex={rowIndex === controlIndex}
                                                    rowIndex={rowIndex}
                                                    hasControlsColumn={hasControlsColumn}
                                                />
                                            ))
                                    }
                                    {isLoadingMore && <td className='no-data-cell load-more-spinner' colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}><LoadingSpinner size={8}/></td>}
                                </tbody>
                            )   
                    }
                </table>
                
                {isInfiniteScroll && <div data-testid="infinite-scroll" ref={infiniteScrollRef} />}
            </div>
        </DndProvider>
    );
};

export default SimpleTable;